module.exports = __webpack_public_path__ + "img/game-1.aef7897b.png";